<!--component html goes here -->
<app-header></app-header>
  
<section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/foods.jpeg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <!-- <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0">{{modelObject.nameEn}}  </h4>
              </div>
          </div> -->
           <!--end col-->
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/souvenirs">Souvenir</a></li>
                  <li class="breadcrumb-item"><a >Souvenir Details</a></li>
              </ul>
          </nav>
      </div>
  </div> <!--end container-->
</section><!--end section-->
<section class="section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 col-md-6 col-12" ngbSlide *ngFor="let item of files">
          <img src="{{item.imageURL}}" style="width: 100%;" class="img-fluid rounded" alt="">
        </div>
        <!--end col-->
        <div class="col-lg-7 col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
          <div class="section-title ms-lg-4">
            <h4 class="title mb-4">{{modelObject.nameEn}}</h4>
            <p class="text-muted">{{modelObject.descriptionEn}}.</p>
            <a href="javascript:void(0)" class="btn btn-primary mt-3">{{modelObject.countryNameEn}}</a>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->
      <div class="row justify-content-center">
        <div class="col-md-10 mt-4 pt-2">
            <div class="card shadow rounded border-0 mt-4">
                <div class="card-body">
                  <ngx-simplebar style="max-height: 360px;">
                    <h5 class="card-title mb-0">Comments :</h5>
                          <ul class="media-list list-unstyled mb-0">
                              <li class="mt-4" *ngFor="let item of EvaluationSouvenorsList">
                                <div class="d-flex justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <a class="pe-3" href="javascript:void(0)">
                                      <img src="assets/images/client/01.jpg" class="img-fluid avatar avatar-md-sm rounded-circle shadow"
                                        alt="img">
                                    </a>
                                    
                                    <div class="flex-1 commentor-detail">
                                      <h6 class="mb-0"><a href="javascript:void(0)" class="text-dark media-heading">Lorenzo Peterson</a>
                                      </h6>
                                      <small class="text-muted">{{item.date|date:'dd/MM/yyyy hh:MM'}}</small>
                                    </div>
                                  </div>
                                  <a >
                                  <ngb-rating [max]="5" [(rate)]="item.numberOfStars" [readonly]="true" style="font-size: 30px;"> </ngb-rating>
                                </a>
                                </div>
                                <div class="overflow-hidden flex-1 ms-2">
                                  <div class="d-flex justify-content-between text-muted p-3 bg-light rounded">
                                      <p  >{{item.comment}}
                                      </p>
                                      <small class="text-muted"><a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(item.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-2" style="width: 77px; height: 30px; font-size: 10px;"> Report</a>
                                      </small>
                                  </div>
                              </div>
                                <!-- <div class="mt-3">
                                  <div class="mt-3 text-muted p-3 bg-light rounded">
                                    <div class="row">
                                      <div class="col-md-9">
                                        <p  >{{item.comment}}
                                        </p>
                                      </div>
                                      <div class="col-md-3">
                                        <a  href="javascript:void(0)" data-bs-toggle="modal" (click)="setCommentId(item.id)" data-bs-target="#LoginForm" class="btn btn-primary ms-md-4"> Report</a>
                                      </div>
                                    </div>
                
                                  </div>
                                </div> -->
                              </li>
                            </ul>
                  </ngx-simplebar>
                </div>
              </div>
              <!-- Comments -->
              <div class="card shadow rounded border-0 mt-4">
                <div class="card-body">
                  <h5 class="card-title mb-0">Leave A Comment :</h5>
                  <form class="mt-3">
                    <div class="row">
                       <div class="col-md-12">
                        <div class="form-group position-relative">
                            <label>Your Comment</label>
                            <i-feather name="message-circle" class="fea icon-sm icons"></i-feather>
                          <div class="form-icon position-relative">
                            <textarea id="message" placeholder="Your Comment" rows="5" name="message" class="form-control ps-5"
                            required="" [(ngModel)]="myComment"></textarea>
                          </div>
                          <div >
                            <ngb-rating  [max]="5" [(rate)]="myStars" [readonly]="false"></ngb-rating>
                          </div>
                          <div>
                          </div>
                        </div>
                     
                      </div>
                    
      
                      <div class="col-md-12">
                        <div class="send d-grid">
                          <button type="submit" class="btn btn-primary" (click)="Save()">Comment</button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <!--end form-->
                </div>
              </div>
        </div>
    </div>
    </div>
    <!--enc container-->
  </section>
  <!--the Report for coments-->
  <div *ngIf="ReportForm" class="modal fade" id="LoginForm" tabindex="-1" aria-labelledby="LoginForm-title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded shadow border-0">
            <div class="modal-header border-bottom">
                <h5 class="modal-title" id="LoginForm-title">Send Report</h5>
                <button type="button" class="btn btn-icon btn-close" data-bs-dismiss="modal" id="close-modal"><i class="uil uil-times fs-4 text-dark"></i></button>
            </div>
            <div class="modal-body">
              <h3 class="modal-title" id="LoginForm-title">Your Report</h3>
                <div class="bg-white p-3 rounded box-shadow">
                  <div class="row">
                    <textarea class="text-muted mb-0" rows="6" [(ngModel)]="message"> </textarea>                                                        
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #closebutton id="closebutton">Close</button>
                <button type="button" class="btn btn-primary" (click)="SendReport()">Send</button>
            </div>
        </div>
    </div>
</div>
  <!--end Report for coments-->

  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
